// Types
import type { LogoShapeProps } from '@/types/components/atoms/shapes/logo'

const LogoShapeAtom = (props: LogoShapeProps) => {
	// Props
	const { mode } = props

	// Variables
	let rectColor = '#fff'
	let backColor = '#25347a'
	let trianglesColor = '#ce202f'
	let starsColor = '#ffc52f'
	let textColor = '#25347a'
	const newBGColor = '#404786'

	if (mode === 'text-white') textColor = '#fff'
	else if (mode === 'grey') {
		backColor = '#272324'
		trianglesColor = '#626365'
		starsColor = '#c9cbcc'
		textColor = '#272324'
	} else if (mode === 'white') {
		rectColor = newBGColor
		backColor = '#fff'
		trianglesColor = '#fff'
		starsColor = newBGColor
		textColor = '#fff'
	}

	return (
		<svg viewBox="0 0 1000 826">
			<rect fill={rectColor} x="0" y="152.7" width="1000" height="516.2" />

			{/* Back */}
			<path
				fill={backColor}
				d="M13.3,391.3c7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.5,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.7-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.5,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.8,6.7,4.5,0,10.1-3.6,15.9-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.8,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.8,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.8,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.8,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.7-11.1,13.1-.8,17,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1h0c13.1-.8,17.1,6.8,19.7,11.8,1.2,2.4,2.2,4.1,3.7,5.2v-244.4H0v245.6c4-1,8.5-3.9,13.3-7"
			/>

			<path
				fill={backColor}
				d="M695.7,614.6l74.3-82.6-36.5-40.6,8.7-7.8s21.7,24.2,29.5,32.8v-31.1h11.7v31.7c7.8-8.7,30.1-33.5,30.1-33.5l8.7,7.8-36.5,40.6,73.7,82.6h-163.6ZM510.7,614.6l74.3-82.6-36.5-40.6,8.7-7.8s21.7,24.2,29.5,32.8v-31.1h11.7v31.7c7.8-8.7,30.1-33.5,30.1-33.5l8.7,7.8-36.5,40.6,73.7,82.6h-163.6ZM325.6,614.6l74.3-82.6-36.5-40.6,8.7-7.8s21.7,24.2,29.5,32.8v-31.1h11.7v31.7c7.8-8.7,30.1-33.5,30.1-33.5l8.7,7.8-36.5,40.6,73.7,82.6h-163.6ZM140.6,614.6l74.3-82.6-36.5-40.6,8.7-7.8s21.7,24.2,29.5,32.8v-31.1h11.7v31.7c7.8-8.7,30.1-33.5,30.1-33.5l8.7,7.8-36.5,40.6,73.7,82.6h-163.6ZM986.8,455.5c-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.3-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-7.2,4.6-14,9-21.6,9.1h0s-.2,0-.2,0h0c-12.6,0-16.5-7.5-19.1-12.4-2.4-4.4-3.4-6.5-9.7-6.1-7.5.4-14.6,5-21.5,9.4-6.4,4.1-12.5,8-19,8.9v201.2h999.9v-201.7c-8-2-11-7.7-13.1-11.7"
			/>

			{/* Triangles */}
			<polygon fill={trianglesColor} points="163.1 605.3 223 540.2 282.2 605.3 163.1 605.3" />
			<polygon fill={trianglesColor} points="348.1 605.3 408.1 540.2 467.2 605.3 348.1 605.3" />
			<polygon fill={trianglesColor} points="533.1 605.3 593.1 540.2 652.3 605.3 533.1 605.3" />
			<polygon fill={trianglesColor} points="718.2 605.3 778.2 540.2 837.3 605.3 718.2 605.3" />

			{/* Stars */}
			<polygon fill={starsColor} points="872.8 257.7 849.5 275.5 859.2 247.8 835.1 231.2 864.4 231.9 872.8 203.8 881.1 231.9 910.4 231.2 886.3 247.8 896 275.5 872.8 257.7" />

			<path
				fill={starsColor}
				d="M421.3,385.1c2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.7-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.5,6.7,9.8,6.7,4.5,0,10.1-3.6,15.9-7.4,7.7-4.9,16.3-10.5,26.7-11.1,13.1-.8,17.1,6.8,19.7,11.8,2.4,4.5,3.6,6.7,9.7,6.7,4.5,0,10.1-3.6,16-7.4,7.7-4.9,16.3-10.5,26.6-11.1,11.5-.7,16,5.1,18.7,9.9,4.5-13.4,6.9-27.8,6.9-42.7,0-74.3-60.3-134.6-134.6-134.6s-134.6,60.3-134.6,134.6,2.2,27.7,6.2,40.5c6.3-3.8,13.3-7.2,21.2-7.7,13.1-.8,17.1,6.8,19.7,11.8"
			/>

			{/* Text */}
			<polygon fill={textColor} points="21.1 20.8 0 20.8 0 7 59.4 7 59.4 20.8 38.4 20.8 38.4 101.5 21.1 101.5 21.1 20.8" />
			<polygon fill={textColor} points="72.6 66.6 62.2 77.9 62.2 64.7 72.6 53.3 72.6 0 89.4 0 89.4 34.9 99.8 23.5 99.8 36.8 89.4 48.2 89.4 101.5 72.6 101.5 72.6 66.6" />
			<rect fill={textColor} x="109" y="31.8" width="16.8" height="69.7" />

			<path
				fill={textColor}
				d="M129.4,129.6c-2.8,1.1-6.4,1.9-10.4,1.9-7,0-13.5-3.9-13.5-13.3s6.9-13,12.7-16.8h5.7c-6,6.2-8.4,12.3-8.4,16.4s3.1,7.4,7,7.4,4.1-.4,5.5-1l1.4,5.3Z"
			/>

			<path
				fill={textColor}
				d="M186.5,99.7c-3.9,1.5-9.7,2.8-16.5,2.8-23,0-32.7-16.1-32.7-35.9s10.3-36,33.7-36,11.5,1.6,14.6,2.8l-.9,13.3c-3-1.5-7.2-3.4-11.8-3.4-12.7,0-18.3,8.5-18.3,23.4s6.2,23,19.1,23,9.6-1.9,11.9-3.4l.9,13.3Z"
			/>

			<path
				fill={textColor}
				d="M196.8,0h16.8v40.7h.4c3-4.3,6.9-10,17.3-10,15.8,0,20.6,11.8,20.6,25.8v44.9h-16.8v-41.8c0-10.7-2.7-15.2-9.6-15.2s-11.9,7.4-11.9,16.4v40.6h-16.8V0Z"
			/>

			<path
				fill={textColor}
				d="M295.8,30.7c14.2,0,30.6,7.4,30.6,35.9s-16.4,36-30.6,36-30.7-6.8-30.7-36,16.5-35.9,30.7-35.9M295.8,90.7c10.8,0,13.3-12.4,13.3-24.1s-2.4-23.9-13.3-23.9-13.4,12.3-13.4,23.9,2.6,24.1,13.4,24.1"
			/>

			<path
				fill={textColor}
				d="M305.1,129.6c-2.8,1.1-6.4,1.9-10.4,1.9-7,0-13.5-3.9-13.5-13.3s6.9-13,12.7-16.8h5.7c-6,6.2-8.4,12.3-8.4,16.4s3.1,7.4,7,7.4,4.1-.4,5.5-1l1.4,5.3Z"
			/>

			<polygon fill={textColor} points="19.9 721.9 0 721.9 0 708.9 55.9 708.9 55.9 721.9 36.2 721.9 36.2 797.7 19.9 797.7 19.9 721.9" />

			<polygon
				fill={textColor}
				points="68.3 764.9 58.5 775.6 58.5 763.1 68.3 752.4 68.3 702.3 84.1 702.3 84.1 735.1 93.9 724.4 93.9 736.9 84.1 747.6 84.1 797.7 68.3 797.7 68.3 764.9"
			/>

			<rect fill={textColor} x="102.6" y="732.2" width="15.8" height="65.6" />

			<path
				fill={textColor}
				d="M121.7,824.2c-2.7,1-6,1.8-9.8,1.8-6.6,0-12.7-3.7-12.7-12.5s6.5-12.2,12-15.8h5.3c-5.6,5.9-7.9,11.6-7.9,15.4s2.9,7,6.6,7,3.8-.4,5.2-.9l1.3,5Z"
			/>

			<path
				fill={textColor}
				d="M175.5,796.1c-3.7,1.4-9.2,2.7-15.5,2.7-21.6,0-30.8-15.1-30.8-33.7s9.7-33.9,31.7-33.9,10.8,1.5,13.7,2.7l-.9,12.5c-2.8-1.4-6.7-3.2-11.1-3.2-12,0-17.2,8-17.2,22s5.9,21.6,17.9,21.6,9-1.8,11.2-3.2l.9,12.5Z"
			/>

			<path
				fill={textColor}
				d="M185.2,702.3h15.8v38.3h.4c2.8-4.1,6.5-9.4,16.3-9.4,14.9,0,19.3,11.1,19.3,24.3v42.3h-15.8v-39.3c0-10.1-2.5-14.3-9-14.3s-11.2,7-11.2,15.4v38.2h-15.8v-95.5Z"
			/>

			<path
				fill={textColor}
				d="M278.3,731.2c13.4,0,28.8,7,28.8,33.7s-15.4,33.9-28.8,33.9-28.9-6.4-28.9-33.9,15.5-33.7,28.9-33.7M278.3,787.6c10.2,0,12.5-11.7,12.5-22.7s-2.3-22.5-12.5-22.5-12.6,11.6-12.6,22.5,2.4,22.7,12.6,22.7"
			/>

			<path fill={textColor} d="M287,824.2c-2.7,1-6,1.8-9.8,1.8-6.6,0-12.7-3.7-12.7-12.5s6.5-12.2,12-15.8h5.3c-5.6,5.9-7.9,11.6-7.9,15.4s2.9,7,6.6,7,3.8-.4,5.2-.9l1.3,5Z" />

			<polygon
				fill={textColor}
				points="387.9 7 408.5 7 439.9 81.2 440.2 81.2 440.2 7 455.8 7 455.8 101.5 435.1 101.5 403.9 27.9 403.6 27.9 403.6 101.5 387.9 101.5 387.9 7"
			/>

			<path
				fill={textColor}
				d="M530.5,0v89.6c0,5,.1,9.3.5,11.9h-15.7c-.3-2-.5-6.1-.5-10.8h-.4c-2.7,6-7.7,11.9-18.5,11.9-17.3,0-24.5-16.5-24.5-35.9s9.1-36,24.1-36,15.6,5.7,18,11.1h.3V0h16.8ZM500.5,90.2c9.9,0,13.3-10.7,13.3-23.8s-3.8-23.4-13-23.4-12.6,9.1-12.6,23,2.6,24.2,12.3,24.2"
			/>

			<path
				fill={textColor}
				d="M597.1,98.1c-3.5,1.5-10.8,4.5-20.8,4.5-22.5,0-32.2-16.1-32.2-34.9s11-36.9,28.7-36.9,27.9,8.8,27.9,37.2v3.3h-40.3c0,11.9,4.7,19.1,17.7,19.1s15.2-3.1,18.3-5.4l.8,13.3ZM584.4,60.6c0-12.3-4.1-18.5-11.6-18.5s-12.4,9.3-12.4,18.5h24.1Z"
			/>

			<polygon
				fill={textColor}
				points="613.6 0 630.4 0 630.4 59.7 630.8 59.7 651.2 31.8 669.1 31.8 644.6 63.3 671.4 101.5 651.9 101.5 630.8 67.5 630.4 67.5 630.4 101.5 613.6 101.5 613.6 0"
			/>

			<polygon fill={textColor} points="702.9 0 692.6 33.6 679.6 33.6 686.6 0 702.9 0" />

			<path
				fill={textColor}
				d="M719.8,35.9c4.7-2.2,11.4-5.1,22.1-5.1,21.6,0,26.7,10.6,26.7,28v30.4c0,5,.5,9.6.9,12.3h-15.2c-.8-2.7-1-6.1-1-9.5h-.3c-4.2,5.7-9.5,10.6-19.5,10.6s-20.8-7.4-20.8-20.4c0-18.9,15.4-23.7,36.7-23.7h3.4v-2.6c0-6.9-3.4-13.3-13-13.3s-15.8,4.1-19.1,6.8l-.9-13.5ZM742,4.6l8.7,19.5h-10.6l-13.8-19.5h15.7ZM752.8,67.4h-1.5c-14.3,0-22.9,3-22.9,13.1s4.2,10.7,10.7,10.7c10,0,13.7-7.4,13.7-19.9v-3.9Z"
			/>

			<polygon
				fill={textColor}
				points="889.5 47.2 889.2 47.2 877 101.5 858.6 101.5 839.8 31.8 857.1 31.8 868.4 86 868.6 86 880.4 31.8 899.5 31.8 911 86 911.2 86 922.5 31.8 938.7 31.8 920.2 101.5 901.9 101.5 889.5 47.2"
			/>

			<path
				fill={textColor}
				d="M969.4,30.7c14.2,0,30.6,7.4,30.6,35.9s-16.4,36-30.6,36-30.7-6.8-30.7-36,16.5-35.9,30.7-35.9M969.4,90.7c10.8,0,13.3-12.4,13.3-24.1s-2.4-23.9-13.3-23.9-13.4,12.3-13.4,23.9,2.6,24.1,13.4,24.1"
			/>

			<path
				fill={textColor}
				d="M808,30.7c14.2,0,30.6,7.4,30.6,35.9s-16.4,36-30.6,36-30.7-6.8-30.7-36,16.5-35.9,30.7-35.9M808,90.7c10.8,0,13.3-12.4,13.3-24.1s-2.4-23.9-13.3-23.9-13.4,12.3-13.4,23.9,2.6,24.1,13.4,24.1"
			/>

			<path
				fill={textColor}
				d="M387.7,748.4h28.8v46.5c-4.6,2.4-12.5,4.6-24.1,4.6-28.5,0-43.7-19.3-43.7-45.7s15.1-45.7,43.7-45.7,18.2,2.3,21.6,3.8l-.9,14.6c-5.2-3.2-12.3-5.5-20.5-5.5-17.3,0-26.6,14.3-26.6,32.7s9,32.7,25.7,32.7,7.3-.8,9.4-1.7v-23.9h-13.5v-12.5Z"
			/>

			<path
				fill={textColor}
				d="M459.6,731.6c13.4,0,28.8,7,28.8,33.7s-15.4,33.9-28.8,33.9-28.9-6.4-28.9-33.9,15.5-33.7,28.9-33.7M459.6,788c10.2,0,12.5-11.7,12.5-22.7s-2.3-22.5-12.5-22.5-12.6,11.6-12.6,22.5,2.4,22.7,12.6,22.7"
			/>

			<polygon fill={textColor} points="495 732.6 511.3 732.6 524.7 783.2 524.9 783.2 538.4 732.6 553.7 732.6 533.6 798.2 515 798.2 495 732.6" />

			<path
				fill={textColor}
				d="M610.2,795c-3.3,1.4-10.2,4.2-19.6,4.2-21.1,0-30.3-15.1-30.3-32.8s10.3-34.7,27-34.7,26.2,8.3,26.2,35v3.1h-37.9c0,11.2,4.5,17.9,16.7,17.9s14.3-2.9,17.2-5.1l.8,12.5ZM598.2,759.7c0-11.6-3.8-17.4-10.9-17.4s-11.7,8.8-11.7,17.4h22.7Z"
			/>

			<path
				fill={textColor}
				d="M626.2,743.5c0-4.1-.1-7.9-.5-10.8h14.3c.1,3.9.5,8,.5,12h.3c1.9-5.1,6.9-13,16.7-13s1.8.3,2.7.4v14.8c-1.4-.4-2.8-.6-4.5-.6-6.5,0-13.6,3.9-13.6,16.2v35.9h-15.8v-54.7Z"
			/>

			<path
				fill={textColor}
				d="M670.5,743.5c0-4.1-.1-7.9-.5-10.8h14.8c.1,3.3.5,6.8.5,10.1h.4-.1c2.3-3.9,6.7-11.1,17.4-11.1s19.3,11.1,19.3,24.3v42.3h-15.8v-39.3c0-10.1-2.5-14.3-9-14.3s-11.2,7-11.2,15.4v38.2h-15.8v-54.7Z"
			/>

			<path
				fill={textColor}
				d="M736.2,743.3c0-4.7-.3-8.3-.5-10.7h15.8c.1,3.4.5,6.9.5,10.3h.3c2.4-5.1,7.5-11.3,16.5-11.3s14.6,6.9,16.5,10.4c3.2-4.6,7.9-10.4,17.6-10.4,14.3,0,18.8,10.2,18.8,26.1v40.5h-15.8v-41.4c0-8.1-2.5-12.2-8.4-12.2s-10.7,6.6-10.7,13.9v39.7h-15.8v-41.4c0-8.1-2.5-12.2-8.4-12.2s-10.7,6.6-10.7,13.9v39.7h-15.8v-54.9Z"
			/>

			<path
				fill={textColor}
				d="M883.7,795c-3.3,1.4-10.2,4.2-19.6,4.2-21.1,0-30.3-15.1-30.3-32.8s10.3-34.7,27-34.7,26.2,8.3,26.2,35v3.1h-37.9c0,11.2,4.5,17.9,16.7,17.9s14.3-2.9,17.2-5.1l.8,12.5ZM871.7,759.7c0-11.6-3.8-17.4-10.9-17.4s-11.7,8.8-11.7,17.4h22.7Z"
			/>

			<path
				fill={textColor}
				d="M899.2,743.5c0-4.1-.1-7.9-.5-10.8h14.8c.1,3.3.5,6.8.5,10.1h.4-.1c2.3-3.9,6.8-11.1,17.4-11.1s19.4,11.1,19.4,24.3v42.3h-15.8v-39.3c0-10.1-2.5-14.3-9-14.3s-11.2,7-11.2,15.4v38.2h-15.8v-54.7Z"
			/>

			<path
				fill={textColor}
				d="M971.1,719.1l15.8-4.8v18.3h13.1v11.6h-13.1v34c0,7,2.5,9,7.1,9s4.8-.8,6-1.4v11.2c-2.4,1.1-5.9,2.2-10.6,2.2-11.7,0-18.3-5.3-18.3-19.1v-35.9h-10.4v-11.6h10.4v-13.5Z"
			/>
		</svg>
	)
}

export default LogoShapeAtom
